/**
 * Storage keys shared with the previous frontend. Keeping them identical means
 * signed-in users stay signed in, and in-flight bookings/invites survive the
 * deploy.
 */
export const STORAGE_KEYS = {
  user: 'user',
  pendingBooking: 'nappr:postAuthBooking',
  pendingInvite: 'pendingInviteToken',
};

function safe(storageName) {
  try {
    return typeof window !== 'undefined' ? window[storageName] : null;
  } catch {
    return null;
  }
}

function read(storageName, key) {
  const store = safe(storageName);
  if (!store) return null;
  try {
    const raw = store.getItem(key);
    return raw == null ? null : JSON.parse(raw);
  } catch {
    return null;
  }
}

function write(storageName, key, value) {
  const store = safe(storageName);
  if (!store) return;
  try {
    if (value == null) store.removeItem(key);
    else store.setItem(key, JSON.stringify(value));
  } catch {
    // Quota exceeded or storage disabled — nothing we can do.
  }
}

export const local = {
  get: (key) => read('localStorage', key),
  set: (key, value) => write('localStorage', key, value),
  remove: (key) => write('localStorage', key, null),
};

export const session = {
  get: (key) => read('sessionStorage', key),
  set: (key, value) => write('sessionStorage', key, value),
  remove: (key) => write('sessionStorage', key, null),
};

/** The invite token was historically stored as a raw string, not JSON. */
export const pendingInvite = {
  get() {
    const store = safe('sessionStorage');
    try {
      return store?.getItem(STORAGE_KEYS.pendingInvite) || null;
    } catch {
      return null;
    }
  },
  set(token) {
    const store = safe('sessionStorage');
    try {
      store?.setItem(STORAGE_KEYS.pendingInvite, token);
    } catch {
      /* ignore */
    }
  },
  clear() {
    const store = safe('sessionStorage');
    try {
      store?.removeItem(STORAGE_KEYS.pendingInvite);
    } catch {
      /* ignore */
    }
  },
};
